module.exports = __webpack_public_path__ + "static/media/people.d11982b6.svg";